import * as Api from '../api/registrationQuery'

const state = {
  queryList: []
}
const mutations = {
  SET_QUERYLIST(state, value) {
    state.queryList = value
  }
}
const actions = {
  /* 查询报名列表 */
  getQueryList({ commit }, params) {
    return Api.getUserLists(params).then(res => {
      const dataList = res.list.map(item => {
        return {
          ...item.examModel,
          examStatus: item.status,
          examId: item.examId,
          id: item.id,
          orderId: item.orderId,
          examineDesc: item.examineDesc,
          examModel: item.examModel,
          status: item.status,
          actualPrice: item.actualPrice,
          applyName: item.applyName,
          payType: item.payType,
        }
      })
      commit('SET_QUERYLIST', dataList)
      return res
    })
  }
}
export default {
  state,
  mutations,
  actions
}
